const notificationVariant = {
  success: 'green',
  error: 'rgba(255, 33, 22, 100%)',
  warning: '#FD7E14',
  info: 'primary',
}

export default notificationVariant